// extracted by mini-css-extract-plugin
export default {"toast":"NetworkStatus_toast__OK4vr"};